// Card 17trt6jbffe: chave estavel de um item da lista de conversas, mesmo
// antes de a conversa existir no banco (id nulo -> chave natural).
export function conversationKey(item) {
  if (!item) return "";
  if (item.id) return `id:${item.id}`;
  const key = item.key || {};
  return [key.type, key.partnerId, key.customerId, key.classId]
    .map((part) => String(part || "").toLowerCase())
    .join("|");
}

// Mesma conversa? Compara pelo id (texto) ou pela chave natural.
export function sameConversation(a, b) {
  if (!a || !b) return false;
  if (a.id && b.id) return String(a.id) === String(b.id);
  const ka = a.key || {};
  const kb = b.key || {};
  return (
    ka.type === kb.type &&
    String(ka.partnerId || "").toLowerCase() ===
      String(kb.partnerId || "").toLowerCase() &&
    String(ka.customerId || "").toLowerCase() ===
      String(kb.customerId || "").toLowerCase() &&
    String(ka.classId || "").toLowerCase() ===
      String(kb.classId || "").toLowerCase()
  );
}

// Compara cursores INT8 (texto) sem Number(): ids passam de MAX_SAFE_INTEGER.
export function cursorGreater(a, b) {
  const left = String(a || "");
  const right = String(b || "");
  if (!/^\d+$/.test(left)) return false;
  if (!/^\d+$/.test(right)) return true;
  if (left.length !== right.length) return left.length > right.length;
  return left > right;
}
